<template>
  <div class="select_dialog_embed">
    <div class="complaint_order_embed_msg">
      <div class="select_dialog_embed_box"
           :class="{'w650' : showType === 'log', 'w_percent100' : showType === 'orderDetail'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--订单详情-->
        <div v-if="showType === 'orderDetail'" class="select_dialog_embed_box_content order_detail">
          <div class="order_detail_top mt5 ml5 mr5 mb10">
            <table class="table tb_border">
              <tbody>
              <tr>
                <td class="fwb text_right">内部订单号:</td>
                <td class="text_left">{{orderDetailMsg.OrderId}}</td>
                <td class="fwb text_right">状态：</td>
                <td class="text_left">{{orderDetailMsg.SysStatusName}}</td>
                <td class="fwb text_right">平台订单号:</td>
                <td class="text_left">{{orderDetailMsg.OutOrderId}}</td>
                <td class="fwb text_right">下单时间:</td>
                <td class="text_left">假的2019/03/15 16:53:00</td>
              </tr>
              <tr>
                <td class="fwb text_right">渠道:</td>
                <td class="text_left">假的kc_渠道</td>
                <td class="fwb text_right">店铺:</td>
                <td class="text_left">假的尚动天猫</td>
                <td class="fwb text_right">付款时间:</td>
                <td class="text_left">假的2019/03/15 16:53:00</td>
                <td class="fwb text_right">交单时间:</td>
                <td class="text_left">假的2019/03/15 16:53:00</td>
              </tr>
              <tr>
                <td class="fwb text_right">发货时间:</td>
                <td class="text_left">假的2019/03/15 16:53:00</td>
                <td class="fwb text_right">订单金额:</td>
                <td class="text_left">假的13000.00</td>
                <td class="fwb text_right">优惠金额:</td>
                <td class="text_left">假的65.31</td>
                <td class="fwb text_right">成交金额:</td>
                <td class="text_left fcDel">假的65.31</td>
              </tr>
              <tr>
                <td class="fwb text_right">订单成本:</td>
                <td class="text_left">假的544</td>
                <td class="fwb text_right">退款金额:</td>
                <td class="text_left">假的13000.00</td>
                <td class="fwb text_right">运费金额:</td>
                <td class="text_left">假的65.31</td>
                <td class="fwb text_right">运费成本:</td>
                <td class="text_left fcDel">假的65.31</td>
              </tr>
              <tr>
                <td class="fwb text_right">快递公司:</td>
                <td class="text_left">假的顺丰快递</td>
                <td class="fwb text_right">快递单号:</td>
                <td class="text_left">假的98545454546</td>
                <td class="fwb text_right">买家ID:</td>
                <td class="text_left" colspan="3">假的都是对的</td>
              </tr>
              <tr>
                <td class="fwb text_right">收货信息:</td>
                <td class="text_left" colspan="7">假的顺丰快递</td>
              </tr>
              <tr>
                <td class="fwb text_right">买家备注:</td>
                <td class="text_left" colspan="3">假的顺丰快递</td>
                <td class="fwb text_right">卖家备注:</td>
                <td class="text_left" colspan="3">假的顺丰快递</td>
              </tr>
              <tr>
                <td class="fwb text_right">内部备注:</td>
                <td class="text_left" colspan="3">假的顺丰快递</td>
                <td class="fwb text_right">系统备注:</td>
                <td class="text_left" colspan="3">假的顺丰快递</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="order_detail_bottom mt5 ml5 mr5 mb10">
            <table class="table tb_border">
              <thead>
              <tr>
                <th>货号</th>
                <th>品名</th>
                <th>颜色</th>
                <th>尺码</th>
                <th>零售价</th>
                <th>单价</th>
                <th>数量</th>
                <th>优惠</th>
                <th>合计</th>
                <th>成本单价</th>
                <th>成本价合计</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
                <td>假的</td>
              </tr>
              <tr>
                <td colspan="7"></td>
                <td>合计</td>
                <td>假的5454</td>
                <td>合计</td>
                <td>假的16225</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--新增/修改工单-->
        <div v-if="showType === 'add' || showType === 'modify'" class="select_dialog_embed_box_content add_modify">
          <div>
            <label><i>*</i>申诉订单号：</label>
            <input type="text" title="申诉订单号" maxlength="50" v-model.trim="complaintNum" :disabled="showType === 'modify'">
          </div>
          <div>
            <label><i>*</i>申请赔付金额：</label>
            <input type="text" title="申请赔付金额" maxlength="20" v-model.trim="payAmount">
          </div>
          <div class="result mb20">
            <label><i>*</i>申诉原因：</label>
            <textarea title="申诉原因" v-model.trim="complaintReason"></textarea>
          </div>
        </div>

        <!--日志-->
        <div v-if="showType === 'log'" class="select_dialog_embed_box_content complaint_order_embed_msg_log">
          <table class="table tb_border">
            <thead>
            <tr>
              <th>操作人</th>
              <th>操作时间</th>
              <th>操作内容</th>
            </tr>
            </thead>
            <tbody v-if="logList.length">
            <tr v-for="(item, index) in logList" :key="index">
              <td>{{item.CreaterName}}</td>
              <td>{{item.CreateTime | time}}</td>
              <td>{{item.Content}}</td>
            </tr>
            </tbody>
            <tbody v-if="!logList.length">
            <tr>
              <td colspan="3">{{logErr}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!--撤回-->
        <div v-if="showType === 'pullBack'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb20">是否确定撤回所选工单？</p>
        </div>

        <!--删除-->
        <div v-if="showType === 'del'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb20">是否确定删除所选工单？</p>
        </div>

        <!--提交-->
        <div v-if="showType === 'submit'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb20">是否确定提交所选工单？</p>
        </div>

        <!--继续提交-->
        <div v-if="showType === 'continueSubmit'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb20">此订单号已经创建过申诉工单，是否继续提交所选工单？</p>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb20">
          <button v-if="showType !== 'orderDetail' && showType !== 'log'" class="btn_normal" @click="submitBtn()">确定</button>
          <button v-if="showType === 'continueSubmit'" class="btn_normal" @click="submitBtn()">继续</button>
          <button class="btn_cancel" @click="cancelBtn()">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'complaint-order-embed-msg',
    props: ['title', 'showType', 'orderMsg'],
    components: {MsgDialog},
    data() {
      return {
        id: 0, // 编辑的id
        complaintNum: null, // 申诉工单号
        payAmount: null, // 申请赔付金额
        complaintReason: null, // 申诉原因
        status: 1, // 撤回=1， 提交=2
        orderDetailMsg: {
          OrderId: null, // 内部订单号
          SysStatusName: null, // 订单状态
          OutOrderId: null // 平台/外部订单号
        }, // 订单详情
        logList: [], // 日志列表
        logErr: null, // 日志申请错误
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 获取订单明细
      getOrderDetail() {
        this.$axios.get(this.Global.getOrderDetail(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.orderDetailMsg = res.data.resData;
          }
        });
      },

      // 新增或修改申诉工单
      saveAppealWorkOrder() {
        if (!this.complaintNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写申诉订单号';
          return;
        }
        if (!this.payAmount) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写申请赔付金额';
          return;
        }
        if (!this.complaintReason) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写申诉原因';
          return;
        }
        this.$axios.get(this.Global.saveAppealWorkOrder(this.id, this.complaintNum, this.payAmount, this.complaintReason)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 提交申诉工单或撤回申诉工单
      changeAppealWorkOrderZt() {
        this.$axios.get(this.Global.changeAppealWorkOrderZt(this.orderMsg.OrderNo, this.status)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 查看日志（充值工单、申诉工单）
      getWorkOrderLogList() {
        const params = {
          WorkOrderId: this.orderMsg.OrderNo
        };
        this.$axios.post(this.Global.getWorkOrderLogList, params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.logList = res.data.resData.DataList;
            if (!this.logList.length) {
              this.logErr = '暂时没有相关信息';
            }
          } else {
            this.logList = [];
            this.logErr = res.data.errorMsg;
          }
        });
      },

      // 删除申诉工单
      deleteAppealWorkOrder() {
        this.$axios.get(this.Global.deleteAppealWorkOrder(this.orderMsg.OrderNo)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'add' || this.showType === 'modify') {
          this.saveAppealWorkOrder();
        } else if (this.showType === 'submit' || this.showType === 'continueSubmit' || this.showType === 'pullBack') {
          this.changeAppealWorkOrderZt();
        } else if (this.showType === 'del') {
          this.deleteAppealWorkOrder();
        } else {
          this.cancelBtn(this.showType);
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      console.log(this.showType);
      if (this.showType === 'modify') {
        this.id = this.orderMsg.Id;
        this.complaintNum = this.orderMsg.OrderId;
        this.payAmount = this.orderMsg.Amount;
        this.complaintReason = this.orderMsg.AppealReason;
      } else if (this.showType === 'log') {
        this.getWorkOrderLogList();
      } else if (this.showType === 'submit' || this.showType === 'continueSubmit') {
        this.status = 2;
      } else if (this.showType === 'orderDetail') {
        this.getOrderDetail();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .complaint_order_embed_msg {
    max-height: 100%;
    overflow-y: auto;

    .select_dialog_embed_box {
      &.w650 {
        width: 650px;
      }

      .add_modify {
        text-align: center;

        div {
          margin-top: 20px;

          &.result {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        i {
          color: red;
        }

        label {
          display: inline-block;
          width: 104px;
          text-align: right;
        }

        input[type='text'], textarea {
          width: 50%;
        }

        textarea {
          height: 100px;
          padding: 10px;
          margin-left: 3px;
        }
      }

      .complaint_order_embed_msg_log {
        padding: 10px;

        table {
          td:nth-child(3) {
            text-align: left;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/complaint-order-embed-msg.vue